import { request } from 'Apiv2/handleRequest';

export const getVideo = async (videoId) => {
  const response = await request(`/admin/videos/${videoId}.json`);
  return response.json();
};

export const createVideo = async (videoData) => {
  const response = await request('/admin/videos', 'POST', { video: videoData });
  return response.json();
};

export const updateVideo = async (videoId, videoData) => {
  const response = await request(`/admin/videos/${videoId}`, 'PUT', { video: videoData });
  return response.json();
};
